let innerDomain = document.domain
let split = innerDomain.split('.')
const domain = split[split.length - 2];

function isGjy_(domain) {
    if (process.env.GJY) {
        return true
    }
    if (process.env.NODE_ENV === 'production') {
        if (domain == 'gjychina') {
            return true
        }
    }
    return false
}
let isGjy = isGjy_(domain)

function coursePath() {
    let path = process.env.COURSE_PATH
    if (isGjy) {
        path = path.replace('yzspeixun.com', 'gjychina.com')
    }
    return path
}

function cmsPath() {
    let path = process.env.CMS_PATH
    if (isGjy) {
        path = path.replace('yzspeixun.com', 'gjychina.com')
    }
    return path
}

function managePath() {
    let path = process.env.MANAGE_PATH
    if (isGjy) {
        path = path.replace('yzspeixun.com', 'gjychina.com')
    }
    return path
}

function studentPath() {
    let path = process.env.STUDENT_PATH
    if (isGjy) {
        path = path.replace('yzspeixun.com', 'gjychina.com')
    }
    return path
}

export default (Vue) => {
    Vue.prototype.$gjy = isGjy
    Vue.prototype.$coursePath = coursePath()
    Vue.prototype.$cmsPath = cmsPath()
    Vue.prototype.$managePath = managePath()
    Vue.prototype.$studentPath = studentPath()
}


// WEBPACK FOOTER //
// ./src/util/path.js